import { z } from 'zod'

export const ResolvedFailureEvidenceSchema = z.object({
  tool: z.string().min(1), params: z.record(z.unknown()), result: z.string(), recording_id: z.string().uuid(),
})
export const PlaywrightChronologyDraftSchema = z.object({
  text: z.string().min(1).max(10000),
  timestamp: z.number().nonnegative().nullable(),
  playwright_step: z.string().max(3000).nullable(),
  location: z.string().max(2000).nullable(),
  evidence_calls: z.array(z.number().int().positive()).min(1).max(15),
}).strict()
export const PlaywrightChronologySchema = PlaywrightChronologyDraftSchema.extend({ evidence: z.array(ResolvedFailureEvidenceSchema) })
export const PlaywrightJudgeVerdictSchema = z.object({
  approved: z.boolean(), assessment: z.string(), problems: z.array(z.string()), inconclusive: z.boolean().optional(),
})
export const PlaywrightReviewSchema = z.object({
  status: z.enum(['approved', 'retry_limit', 'budget_exhausted']),
  attempts: z.array(PlaywrightJudgeVerdictSchema).max(4),
})
